import React, { Component } from "react";
import PropTypes from "prop-types";
import PrintComponents from "react-print-components";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Breadcrumbs from "../../CommonComponents/Breadcrumb/Breadcrumb";
import printIcon from "../../assets/icons/print.svg";
import { getPrimaryAccount } from "../../utils/sessionUtil";
import { recordError } from "../../utils/commonUtil";

import {
  NewsPageContainer,
  SectionHeading,
  FundHeader,
  FundId,
  FundContainer,
  NewsDateDetailed,
  NewsDateShort,
  BriefHeader,
  BriefDesc,
  BriefLink,
  ArticlesContainer,
  OuterRow,
  LeftCol,
  RightCol,
  BriefNewsContainer,
  PrintContainer,
  BackContainer,
  BackLink,
  NewsPrintContainer,
  IconPadding,
  DataExportPrint,
  PageHeading,
  BottomGradient,
  SelectedBriefNewsContainer,
  SectionBody,
  EmptyMessageWrapper
} from "./styles";
import { StyleLessButton } from "../../CommonComponents/commonStyles";
import { messageTabChange,messageFullDisplay } from "./action";
import { messagesDerivedStates } from "./selectors";

class MessagesPage extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e, idVal) {
    try {
      e.preventDefault();
      this.props.messageFullDisplay();
      this.props.messageTabChange(idVal);
      sessionStorage.setItem("messagingTid", idVal);
      if (idVal === null) {
        this.props.messageTabChange("0");
        sessionStorage.setItem("messagingTid", 0);
      }
       window.scrollTo(0, 235); 
    } catch (error) {
      recordError(error);
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentDidUpdate(){
    let element =document.getElementById("messageSelected");
    if(element) {
      element.scrollIntoView(true);
      window.scrollTo(0, 0);
    }
  }

  componentWillReceiveProps(np) {
    let tid = sessionStorage.getItem("messagingTid");
    if (np && np.selected === "") {
      if (np.combinedMessagesData.length > 0) {
       this.props.messageTabChange(np.combinedMessagesData[0].tid);
      }
    }
  }

  render() {
    const { messagesData, allmessagesData, selected, combinedMessagesData } = this.props;
    this.breadcrumbRoutes = () => {
      return [
        {
          routeName: "Home",
          path: "/"
        },
        {
          routeName: "Messages & Notifications",
          path: ""
        }
      ];
    };
    return (
      <NewsPageContainer>
        <div>
          <Breadcrumbs breadcrumbRoutes={this.breadcrumbRoutes()} />
          <PageHeading>Messages & Notifications</PageHeading>
          <FundContainer>
            <FundHeader>{getPrimaryAccount().accountName}</FundHeader>
            <FundId>{getPrimaryAccount().accountNumber}</FundId>
          </FundContainer>
        </div>
        <ArticlesContainer>
          <OuterRow noBorder={!(combinedMessagesData && combinedMessagesData.length)} data-test="messageBlock">
            <LeftCol
              style={{ display: this.props.isToggle ? "none" : "block" }}
              xs={24}
              sm={7}
              md={7}
              lg={7}
              xl={7}
            >
              {(combinedMessagesData && combinedMessagesData.length) ? combinedMessagesData.map((data, i) =>
                data.tid === selected ? (
                  <SelectedBriefNewsContainer key={i} id = "messageSelected" >
                    <NewsDateShort>{data.changed}</NewsDateShort>
                    <br />
                    <BriefHeader>
                     <span dangerouslySetInnerHTML={{__html: data.name}}></span>
                    </BriefHeader>
                    <br />
                    <BriefDesc>
                    <span dangerouslySetInnerHTML={{__html: data.field_message_body.substring(0, 70) + (data.field_message_body.length>70?"...":"")}}></span>
                      <BriefLink id = "anrReadMoreSelected" onClick={e => this.handleClick(e, data.tid)}>
                        Read More
                      </BriefLink>
                    </BriefDesc>
                  </SelectedBriefNewsContainer>
                ) : (
                    <BriefNewsContainer key={i}>
                      <NewsDateShort>{data.changed}</NewsDateShort>
                      <br />
                      <BriefHeader>
                        <span dangerouslySetInnerHTML={{__html: data.name}}></span>
                      </BriefHeader>
                      <br />
                      <BriefDesc>
                        <span dangerouslySetInnerHTML={{__html: data.field_message_body.substring(0, 70) + (data.field_message_body.length>70?"...":"")}}></span>
                        <BriefLink id = "anrReadMoreNotSelected" onClick={e => this.handleClick(e, data.tid)}>
                          Read More
                        </BriefLink>
                      </BriefDesc>
                    </BriefNewsContainer>
                  )
              ) : <EmptyMessageWrapper>You currently have no News & Updates.</EmptyMessageWrapper>}
            </LeftCol>
            {combinedMessagesData && combinedMessagesData.map((data, i) =>
              data.tid === selected ? (
                <RightCol
                  key={i}
                  style={{ display: this.props.isToggle ? "block" : "none" }}
                  xs={24}
                  sm={17}
                  md={17}
                  lg={17}
                  xl={17}
                >
                  <BackContainer>
                    <BackLink id = "anrBackLink" onClick={e => this.handleClick(e, null)}>
                      Back
                    </BackLink>
                  </BackContainer>
                  <PrintComponents
                    className="i_print"
                    trigger={
                      <PrintContainer>
                        <StyleLessButton id = "btnMessagePrint">
                          <IconPadding onClick={() => { }} className="ml2">
                            <img src={printIcon} alt="Print Icon" />
                            <DataExportPrint>PRINT</DataExportPrint>
                          </IconPadding>
                        </StyleLessButton>
                      </PrintContainer>
                    }
                  >
                    <NewsPrintContainer>
                      <NewsDateDetailed>{data.changed}</NewsDateDetailed>
                      <SectionHeading>
                        <span dangerouslySetInnerHTML={{__html: data.name}}></span>
                      </SectionHeading>
                      <SectionBody>
                       <span dangerouslySetInnerHTML={{__html: data.field_message_body}}></span>
                      </SectionBody>
                    </NewsPrintContainer>
                  </PrintComponents>
                  <NewsPrintContainer>
                    <NewsDateDetailed>{data.changed}</NewsDateDetailed>
                    <SectionHeading>
                      <span dangerouslySetInnerHTML={{__html: data.name}}></span>
                    </SectionHeading>
                    <SectionBody>
                      <span dangerouslySetInnerHTML={{__html: data.field_message_body}}></span>
                    </SectionBody>
                  </NewsPrintContainer>
                </RightCol>
              ) : null
            )}
            <BottomGradient />
          </OuterRow>
        </ArticlesContainer>
      </NewsPageContainer>
    );
  }
}

MessagesPage.propTypes = {
  allmessagesData: PropTypes.array,
  combinedMessagesData: PropTypes.array,
  isToggle: PropTypes.bool,
  messageFullDisplay: PropTypes.func,
  messageTabChange: PropTypes.func,
  messagesData: PropTypes.array,
  selected: PropTypes.string
}

const mapStateToProps = state => ({
  ...messagesDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  messageTabChange: data => dispatch(messageTabChange(data)),
  messageFullDisplay: () => dispatch(messageFullDisplay())
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MessagesPage)
);